<template>
  <div class="red-envelope-page">

    <!-- Header -->
    <div class="red-envelope-header">
      <a
        href="javascript:void(0)"
        class="red-envelope-back"
        @click.prevent="goToGame"
      >
        <img :src="require('../assets/images/left.png')" />
      </a>

      <div class="red-envelope-page-title">
        Red Envelopes
      </div>
    </div>

    <!-- Main content -->
    <div class="red-envelope-content">

      <div class="red-envelope-card">

        <div class="red-envelope-surprise">
          <span class="surprise-decor">◆</span>
          Surprise
          <span class="surprise-decor">◆</span>
        </div>

        <div class="surprise-divider">
          <span></span>
          <b>•</b>
          <span></span>
        </div>

        <div class="red-envelope-bag-wrap">
          <div class="red-envelope-rays"></div>

          <div class="red-envelope-confetti confetti-1"></div>
          <div class="red-envelope-confetti confetti-2"></div>
          <div class="red-envelope-confetti confetti-3"></div>
          <div class="red-envelope-confetti confetti-4"></div>
          <div class="red-envelope-confetti confetti-5"></div>
          <div class="red-envelope-confetti confetti-6"></div>

          <div class="red-envelope-bag">
            <div class="red-envelope-bag-amount">
              ₹{{ amount }}
            </div>

            <img
              :src="require('../assets/images/red-001 (1).png')"
              alt="Red Envelope"
            />
          </div>
        </div>

        <div class="red-envelope-congrats">
          <span>❦</span>
          Congratulations!
          <span>❦</span>
        </div>

        <div class="red-envelope-received">
          You have received a Red Envelope
        </div>

        <div class="red-envelope-continue-wrap">
          <a
            href="javascript:void(0)"
            class="red-envelope-continue"
            :class="{ disabled: isLoading }"
            @click.prevent="handleContinue"
          >
            {{ isLoading ? "Processing..." : "Continue" }}
          </a>
        </div>

      </div>
    </div>

    <!-- Toast fallback -->
    <div class="toast-content red-envelope-toast" v-show="isErrorShow">
      <div class="toast-message">{{ errorMessage }}</div>
    </div>

    <!-- Result popup -->
    <Teleport to="body">
      <div
        v-if="popupVisible"
        class="red-envelope-popup-overlay"
        @click.self="closePopup"
      >
        <div
          class="red-envelope-popup"
          :class="`popup-${popupType}`"
        >
          <div class="red-envelope-popup-icon">
            <span v-if="popupType === 'success'">✓</span>
            <span v-else-if="popupType === 'deposit'">!</span>
            <span v-else>×</span>
          </div>

          <div class="red-envelope-popup-title">
            {{ popupTitle }}
          </div>

          <div class="red-envelope-popup-message">
            {{ popupMessage }}
          </div>

          <button
            v-if="popupType !== 'success'"
            type="button"
            class="red-envelope-popup-button"
            @click="closePopup"
          >
            OK
          </button>
        </div>
      </div>
    </Teleport>

  </div>

  <PageReload />
</template>


<script>
import { useRouter } from "vue-router";
import axios from "axios";
import { ref } from "vue";

export default {
  setup() {
    const router = useRouter();
    const isErrorShow = ref(false);
    const errorMessage = ref("");
    const amount = ref(0);
    const isLoading = ref(false);
    const popupVisible = ref(false);
    const popupType = ref("");
    const popupTitle = ref("");
    const popupMessage = ref("");
    const routeCode = ref(router.currentRoute.value.query.code || "0");

    const getProductData = async () => {
      try {
        const response = await axios.get(`/get-envelope/${routeCode.value}`);
        if (response.data.success) {
          amount.value = response.data.data.amount;
        } else {
          setErrorMessage(response.data.message);
        }
      } catch (error) {
        console.error(error);
        setErrorMessage(
          error?.response?.data?.message ||
          "An error occurred. Please try again."
        );
      }
    };

    const setErrorMessage = (value) => {
      errorMessage.value = value;
      isErrorShow.value = true;
      setTimeout(() => {
        errorMessage.value = "";
        isErrorShow.value = false;
      }, 2000);
    };

    const showPopup = (type, title, message) => {
      popupType.value = type;
      popupTitle.value = title;
      popupMessage.value = message;
      popupVisible.value = true;
    };

    const closePopup = () => {
      popupVisible.value = false;
    };

    const goToGame = async () => {
      try {
        await router.push({ name: "win" });
      } catch (error) {
        console.error("Back arrow navigation error:", error);
        window.location.hash = "#/win";
      }
    };

    const handleContinue = async () => {
      isLoading.value = true;
      try {
        const response = await axios.get(`/get-envelope/${routeCode.value}`, {
          params: { Continue: true },
        });

        console.log("RED ENVELOPE CONTINUE RESPONSE:", response.status, response.data);

        if (response.data.success) {
          showPopup(
            "success",
            "Red Envelope Claimed!",
            `₹${response.data.data?.amount || amount.value} has been added to your wallet successfully.`
          );

          setTimeout(() => {
            closePopup();
            router.push({ path: "/mine" });
          }, 1800);

        } else {
          const message = response.data.message || "";

          const normalizedMessage = message.toLowerCase();

          if (
            normalizedMessage.includes("auth is requrd") ||
            normalizedMessage.includes("authorization is required") ||
            normalizedMessage.includes("auth is required")
          ) {
            showPopup(
              "error",
              "Login Required",
              "Please login your account first."
            );
          } else if (normalizedMessage.includes("minimum lifetime recharge")) {
            showPopup(
              "deposit",
              "First Deposit Required",
              "First deposit is required to claim this Red Envelope."
            );
          } else {
            showPopup(
              "error",
              "Unable to Claim",
              message || "Unable to claim this Red Envelope."
            );
          }
        }
      } catch (error) {
        console.error(error);

        const message =
          error?.response?.data?.message ||
          "Failed to process the envelope. Please try again.";

        const normalizedMessage = message.toLowerCase();

        if (
          normalizedMessage.includes("auth is requrd") ||
          normalizedMessage.includes("authorization is required") ||
          normalizedMessage.includes("auth is required")
        ) {
          showPopup(
            "error",
            "Login Required",
            "Please login your account first."
          );
        } else if (normalizedMessage.includes("minimum lifetime recharge")) {
          showPopup(
            "deposit",
            "First Deposit Required",
            "First deposit is required to claim this Red Envelope."
          );
        } else {
          showPopup(
            "error",
            "Unable to Claim",
            message
          );
        }
      } finally {
        isLoading.value = false;
      }
    };

    if (!localStorage.getItem("authToken")) {
      setErrorMessage("Not valid");
    } else {
      getProductData();
    }

    return {
      isErrorShow,
      errorMessage,
      amount,
      isLoading,
      handleContinue,
      popupVisible,
      popupType,
      popupTitle,
      popupMessage,
      closePopup,
      goToGame,
    };
  },
};
</script>
<style scoped>
.red-envelope-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #ffffff 0%, #f8fff9 100%);
  overflow-x: hidden;
}

.red-envelope-header {
  position: relative;
  z-index: 3;
  height: 92px;
  display: flex;
  align-items: center;
  padding: 0 26px;
  background: linear-gradient(135deg, #c40000, #f01818);
  color: #fff;
}

.red-envelope-back {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.red-envelope-back img {
  width: 30px;
  height: 30px;
  filter: brightness(0) invert(1);
}

.red-envelope-page-title {
  margin-left: 20px;
  font-size: 28px;
  font-weight: 500;
  letter-spacing: 0.2px;
}


.red-envelope-content {
  position: relative;
  z-index: 2;
  max-width: 720px;
  margin: 18px auto 0;
  padding: 0 20px 44px;
}

.red-envelope-card {
  position: relative;
  padding: 58px 54px 50px;
  background: #fff;
  border-radius: 30px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.13);
  border: 1px solid rgba(190, 0, 0, 0.07);
}

.red-envelope-surprise {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
  color: #c90000;
  font-size: 52px;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
}

.surprise-decor {
  font-size: 18px;
  color: #d40000;
}

.surprise-divider {
  margin: 18px auto 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: #d00000;
}

.surprise-divider span {
  width: 65px;
  height: 3px;
  border-radius: 99px;
  background: linear-gradient(90deg, transparent, #df1010);
}

.surprise-divider span:last-child {
  background: linear-gradient(90deg, #df1010, transparent);
}

.surprise-divider b {
  font-size: 18px;
  line-height: 1;
}

.red-envelope-bag-wrap {
  position: relative;
  width: min(520px, 100%);
  margin: 28px auto 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 430px;
}

.red-envelope-rays {
  position: absolute;
  width: 390px;
  height: 390px;
  border-radius: 50%;
  background:
    repeating-conic-gradient(
      from 0deg,
      rgba(255, 35, 35, 0.18) 0deg 9deg,
      transparent 9deg 18deg
    );
  -webkit-mask-image: radial-gradient(circle, #000 0 52%, transparent 72%);
  mask-image: radial-gradient(circle, #000 0 52%, transparent 72%);
}

.red-envelope-bag {
  position: relative;
  z-index: 2;
  width: 315px;
  max-width: 72%;
  filter:
    hue-rotate(-120deg)
    saturate(1.55)
    brightness(0.98)
    drop-shadow(0 16px 24px rgba(120, 0, 0, 0.22));
}

.red-envelope-bag img {
  display: block;
  width: 100%;
  height: auto;
}

.red-envelope-bag-amount {
  position: absolute;
  z-index: 4;
  left: 50%;
  top: 57%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 48px;
  font-weight: 700;
  white-space: nowrap;
  text-shadow: 0 2px 6px rgba(0, 80, 0, 0.22);
  pointer-events: none;
}

.red-envelope-confetti {
  position: absolute;
  width: 12px;
  height: 20px;
  border-radius: 3px;
  z-index: 1;
  opacity: 0.9;
}

.confetti-1 {
  top: 24%;
  left: 18%;
  background: #d8b43c;
  transform: rotate(24deg);
}

.confetti-2 {
  top: 35%;
  right: 16%;
  background: #d80a0a;
  transform: rotate(-31deg);
}

.confetti-3 {
  top: 52%;
  left: 11%;
  background: #a9dcac;
  transform: rotate(-14deg);
}

.confetti-4 {
  top: 59%;
  right: 12%;
  background: #d8b43c;
  transform: rotate(37deg);
}

.confetti-5 {
  bottom: 24%;
  left: 20%;
  background: #d80a0a;
  transform: rotate(-25deg);
}

.confetti-6 {
  bottom: 18%;
  right: 19%;
  background: #f7b7b7;
  transform: rotate(18deg);
}

.red-envelope-congrats {
  margin-top: 16px;
  text-align: center;
  color: #c90000;
  font-size: 28px;
  font-weight: 700;
}

.red-envelope-congrats span {
  color: #d8b43c;
  margin: 0 10px;
}

.red-envelope-received {
  margin-top: 10px;
  text-align: center;
  color: #222;
  font-size: 18px;
  line-height: 1.5;
}

.red-envelope-continue-wrap {
  margin-top: 28px;
  display: flex;
  justify-content: center;
}

.red-envelope-continue {
  width: min(520px, 100%);
  min-height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  text-decoration: none;
  color: #fff !important;
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(90deg, #c90000, #f01818);
  box-shadow:
    0 9px 22px rgba(210, 0, 0, 0.24),
    inset 0 1px 0 rgba(255,255,255,0.18);
}

.red-envelope-continue.disabled {
  pointer-events: none;
  opacity: 0.65;
}

.red-envelope-toast {
  z-index: 100000;
}

.red-envelope-popup-overlay {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 18px !important;
  margin: 0 !important;
  box-sizing: border-box !important;
  z-index: 999999 !important;
  background: rgba(0, 35, 12, 0.58);
  backdrop-filter: blur(4px);
}

.red-envelope-popup {
  width: min(360px, 92vw);
  padding: 26px 20px 20px;
  text-align: center;
  border-radius: 24px;
  background: linear-gradient(145deg, #10231a, #07130d);
  border: 1px solid rgba(76, 220, 132, 0.45);
  box-shadow:
    0 0 25px rgba(37, 211, 102, 0.20),
    0 18px 55px rgba(0, 0, 0, 0.55);
}

.red-envelope-popup-icon {
  width: 62px;
  height: 62px;
  margin: 0 auto 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(145deg, #20c86a, #0b8f46);
  box-shadow: 0 0 22px rgba(32, 200, 106, 0.45);
}

.popup-deposit .red-envelope-popup-icon {
  background: linear-gradient(145deg, #d9a52d, #9c6a08);
}

.popup-error .red-envelope-popup-icon {
  background: linear-gradient(145deg, #b93636, #741b1b);
}

.red-envelope-popup-title {
  color: #fff;
  font-size: 21px;
  font-weight: 700;
  margin-bottom: 9px;
}

.red-envelope-popup-message {
  color: #b9d7c4;
  font-size: 14px;
  line-height: 1.5;
}

.red-envelope-popup-button {
  margin-top: 18px;
  min-width: 105px;
  padding: 10px 24px;
  border: 0;
  border-radius: 999px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  background: linear-gradient(90deg, #18b85d, #0a8f45);
  box-shadow: 0 5px 18px rgba(24, 184, 93, 0.30);
}

.red-envelope-popup-button:active {
  transform: scale(0.97);
}

@media (max-width: 700px) {
  .red-envelope-header {
    height: 78px;
    padding: 0 18px;
  }

  .red-envelope-page-title {
    margin-left: 13px;
    font-size: 23px;
  }

  .red-envelope-content {
    margin-top: 12px;
    padding: 0 12px 28px;
  }

  .red-envelope-card {
    padding: 36px 20px 30px;
    border-radius: 24px;
  }

  .red-envelope-surprise {
    gap: 12px;
    font-size: 38px;
  }

  .surprise-decor {
    font-size: 13px;
  }

  .surprise-divider {
    margin-top: 13px;
  }

  .surprise-divider span {
    width: 40px;
  }

  .red-envelope-bag-wrap {
    min-height: 340px;
    margin-top: 14px;
  }

  .red-envelope-rays {
    width: 300px;
    height: 300px;
  }

  .red-envelope-bag {
    width: 270px;
    max-width: 80%;
  }

  .red-envelope-bag-amount {
    font-size: 39px;
  }

  .red-envelope-congrats {
    font-size: 22px;
  }

  .red-envelope-received {
    font-size: 15px;
  }

  .red-envelope-continue {
    min-height: 56px;
    font-size: 20px;
  }
}

@media (max-width: 420px) {
  .red-envelope-card {
    padding-left: 15px;
    padding-right: 15px;
  }

  .red-envelope-surprise {
    font-size: 34px;
  }

  .red-envelope-bag-wrap {
    min-height: 305px;
  }

  .red-envelope-bag {
    width: 245px;
  }

  .red-envelope-bag-amount {
    font-size: 35px;
  }
}

</style>
